// extracted by mini-css-extract-plugin
export default {"root":"orderDetails_root__zwbNC","delete_btn":"orderDetails_delete_btn__to9DE"};